import { connectStaleableLoadable } from 'helpers/loadableHelpers'
import { Guards } from 'interfaces/guards'
import Highlights, { HighlightsDispatchProps, HighlightsStateProps } from 'components/features/pfm/Highlights/Highlights'
import { peergroupsGuard } from 'guards/globalGuards'
import { createInsightsGuard } from 'guards/insightGuards'
import { isPlacementDataPresentSelector, createVisibleInsightsByPlacementSelector } from 'selectors/insightsSelectors'
import { createSelector } from 'reselect'
import { Insight } from 'interfaces/insights'
import { insightShownActionCreator, undismissInsightsByPlacementActionCreator } from 'actions/insightsActions'
import { createForgottenGuardError } from 'helpers/errorHelpers'
import { currentViewportSelector } from 'selectors/viewportSelectors'
import withMobile from 'hocs/withMobile/withMobile'
import { InsightsDispatchProps, InsightsOwnProps, InsightsStateProps } from 'components/features/insights/Insights/Insights'
import { StoreDispatch } from 'interfaces/component'
import { MapDispatchToPropsFunction } from 'react-redux'

const createMapStateToProps = () =>
  createSelector(
    createVisibleInsightsByPlacementSelector<Insight>(),
    currentViewportSelector,
    (insights, viewport): HighlightsStateProps => {
      if (!insights) {
        throw createForgottenGuardError('HighlightsContainer', 'insightsGuard')
      }

      const dismissedInsights = insights.filter(({ is_dismissed }) => is_dismissed)

      return {
        insights: insights.filter(({ is_dismissed }) => !is_dismissed),
        viewport,
        dismissedInsights,
      }
    }
  )

const mapDispatchToProps: MapDispatchToPropsFunction<HighlightsDispatchProps> = (dispatch: StoreDispatch, { placement }: InsightsOwnProps) => ({
  undismiss: (insights: Insight[]) => dispatch(
    undismissInsightsByPlacementActionCreator.request({
      placement,
      insights,
    })
  ),
  onInsightShown: (insight: Insight) => dispatch(insightShownActionCreator(insight)),
})

const guards: Guards = [
  peergroupsGuard,
  createInsightsGuard(),
]

const HighlightsContainerInner = withMobile(Highlights)

const HighlightsContainer = connectStaleableLoadable<
  InsightsStateProps,
  InsightsDispatchProps,
  {},
  InsightsOwnProps
>(guards, isPlacementDataPresentSelector)(createMapStateToProps, mapDispatchToProps)(HighlightsContainerInner)

export default HighlightsContainer
